var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334z",
    fill: "#1080FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#1080FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.174 7.953a.494.494 0 0 0-.567.427c-.08.58-.34 1.1-.74 1.5a2.652 2.652 0 0 1-3.38.3h.5c.273 0 .5-.227.5-.5s-.227-.5-.5-.5h-1.78c-.273 0-.5.227-.5.5v1.78c0 .273.227.5.5.5s.5-.227.5-.5v-.627c.667.54 1.473.827 2.287.827.933 0 1.866-.353 2.58-1.067a3.609 3.609 0 0 0 1.02-2.066.49.49 0 0 0-.42-.574zM4.894 8.053c.247 0 .46-.18.494-.426.08-.58.34-1.1.74-1.5a2.652 2.652 0 0 1 3.38-.3h-.5c-.274 0-.5.226-.5.5 0 .273.226.5.5.5h1.78c.273 0 .5-.227.5-.5v-1.78c0-.274-.227-.5-.5-.5-.274 0-.5.226-.5.5v.626c-1.434-1.16-3.534-1.086-4.86.24a3.609 3.609 0 0 0-1.02 2.067.503.503 0 0 0 .426.567c.014.006.04.006.06.006z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatorder);
export default __webpack_public_path__ + "static/media/repeatorder.7fc961f3c5ee3388cfd7aabebdb29900.svg";
export { ForwardRef as ReactComponent };